import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { PortfolioAddSuccessPage } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddSuccessPage";

export const AddBankProductSuccessPage = () => (
	<PortfolioAddSuccessPage namespace={Resources.Portfolio.AddShared} />
);
